<template>
  <div>
    <v-alert
      v-if="response.choice === 0"
      dense
      type="success"
    >
      Hyväksymme <b>{{ referring }}</b> annetun tarjouksen sellaisenaan
    </v-alert>
    <v-alert
      v-else-if="response.choice === 1"
      dense
      type="info"
      color="amber darken-2"
    >
      Hyväksymme <b>{{ referring }}</b> annetun tarjouksen seuraavin muutoksin:
    </v-alert>
    <v-alert
      v-else
      dense
      icon="cancel"
      type="error"
    >
      Hylkäämme <b>{{ referring }}</b> annetun tarjouksen
    </v-alert>
    <v-alert
      v-if="response.choice === 1"
      class="mb-2"
      type="info"
      color="blue-grey"
      text
      icon="format_quote"
    >
      <p
        style="white-space: pre-line;"
        class="pa-0 ma-0"
        v-text="response.exceptionText"
      />
    </v-alert>
    <p v-if="response.choice === 1" class="mb-0 pl-1 text-caption">
      Tarjous voimassa:
      <b>{{ formatDate(response.offerValidUntilDate) }}</b> klo <b>
        {{ response.offerValidUntilTime }}
      </b> asti<br>
    </p>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'PreviewResponse',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    showSignees: {
      type: Boolean,
      default: false,
    },
    referring: {
      type: String,
      default: '',
    },
    form: {
      type: Object,
      default: () => {},
    },
    companyId: {
      type: String,
      default: '',
    },
    createDate: {
      type: String,
      default: '',
    },
    responses: {
      type: Array,
      default: () => [],
    },
    sellers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    signatures: [],
  }),
  methods: {
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
  },
};
</script>
<style lang="scss">
.borders {
  border: 1px #ddd solid;
}
</style>
